import { Component, OnInit,ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ApiService } from "app/services/api.service";
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CustomValidators } from 'ng2-validation';
import { environment } from '../../environments/environment';
import * as moment from 'moment';


declare var $: any;
declare var jQuery: any;
declare var Webcam: any;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  modalTitle: string;
  showTermsAndConditions: boolean;
  photoTaken: boolean = false;
  submit = true;

  public apiUrl:any;

  public users: any[]=[];
  public genders: any[]=[];
  public municipalities:any;
  public submitted: boolean = false;
  public events: any[]=[];

  public addUserForm: FormGroup;
  public formatedUserForm:any;
  public imageData: any;
  public minDate: string ="";
  public maxDate: string= "";
  public showLoadingSpinner: boolean = true;
  public cardUsername: string;
  public validMobilePhone: boolean = true;
  public validHomePhone: boolean = true;
  public validmunicipalityAccess: boolean;
  public modalMessage: string;
  public userRegistered: boolean;
  public disableSignupButton: boolean = false;

  chosenAvatar: number = 0;
  NumberOfAvatars: any;
  imagesArray: any[]=[]; // init this value with your images
  openModalWindow: boolean = false;
  imagePointer: number = 0;
  openModalWindowObservable: boolean = false;
  imagePointerObservable: number = 0;

  @ViewChild('WebcamContainer') WebcamContainer: ElementRef;
  @ViewChild('datePicker') datePicker: ElementRef;

  constructor(private apiService: ApiService, private FormBuilder: FormBuilder, private router: Router) {
    this.addUserForm = this.FormBuilder.group({
      userName: new FormControl('', Validators.required),
      avatarImage: new FormControl('0'),
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      gender: new FormControl('', Validators.required),
      dateOfBirth: new FormControl('', Validators.required),
      ownImage:'',
      address: this.FormBuilder.group({
        name:'',
        address: new FormControl('', Validators.required),
        zip: new FormControl('', Validators.compose([Validators.required, CustomValidators.number])),
      }),
      mobilePhone: new FormControl('', Validators.required),
      homePhone: new FormControl('', Validators.required),
      municipality: new FormControl('', Validators.required),
      municipalityAccess: new FormControl('', Validators.required)
    });

    this.addUserForm.valueChanges.subscribe(data => {
      // Update the username on the "preview card"
      this.cardUsername = data.userName;

      // Validate phone number
      this.isValidPhoneNumber(data.mobilePhone) || data.mobilePhone == '' ? this.validMobilePhone = true : this.validMobilePhone = false;
      this.isValidPhoneNumber(data.homePhone) || data.homePhone == '' ? this.validHomePhone = true : this.validHomePhone = false;

      // Validate municipalityAccess
      if(data.municipalityAccess === true) {
        this.validmunicipalityAccess = true;
      } else if (data.municipalityAccess === false) {
        this.validmunicipalityAccess = false;
      }
    });
  }

  ngOnInit() {
    this.getMaxDate();
    this.getMinDate();

    // TODO? wrappas i promise för att allt skall laddas klart?
    this.getMunicipalities();
    // this.getAvatars();
    this.getGenders();
    //model = new User();
    this.getAvatars();

    this.apiUrl = this.apiService.getApiUrl();
  }

  isValidPhoneNumber(number) {
    var symbolPattern = new RegExp(/[~`!#$%\^&*=\-\[\]\\';,/{}|\\":<>\?]/, 'g');
    // Check if valid symbols, we're accepting a "+" sign
    if(!symbolPattern.test(number)) {

      var plusSignPattern = /^\+?\d+$/;
      // Check if the number starts with a "+" sign
      if(plusSignPattern.test(number)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  chooseAvatar(index,img){
    this.chosenAvatar = index;
  }

  ngAfterViewInit(){
    Webcam.set({
      width: 182,
      height: 241,
      image_format: 'jpeg',
      jpeg_quality: 90
    });
    Webcam.attach(this.WebcamContainer.nativeElement);

    jQuery(document).ready(() => {
       let minDate = new Date();
       minDate.setFullYear((minDate.getFullYear()-18));

       let maxDate = new Date();
       maxDate.setFullYear((maxDate.getFullYear()-8));

      jQuery(this.datePicker.nativeElement).pickadate({
        selectYears: true,
        selectMonths: true,
        today: false,
        clear: false,
        close: false,
        min: minDate,
        max: maxDate,
        format: 'yyyy-mm-dd',
        formatSubmit: 'yyyy-mm-dd',
        onSet: (context) => {
          this.addUserForm.patchValue({ dateOfBirth: moment(context.select).format('YYYY-MM-DD') });
        }
      });
    });
    
  }

  takeSnap(){
    Webcam.snap((data_uri)=>{
      this.photoTaken = true;
      this.imageData = data_uri;
      if(this.cardUsername == undefined){
        this.cardUsername = "användarnamn"
      }
      document.getElementById('results').innerHTML =
      '<label>Ditt kort:</label>' +
      '<div style="height: 241px;width: 182px;display: block;margin: 0 auto;background-color: #fff;padding: 10px 10px 20px 10px;box-shadow: 0 5px 30px rgba(0,0,0,.30);border-radius: 10px;">' +
      '<div style="background-image: url(' + data_uri + ');width: 100%;height: 0;padding-top: 100%;margin: 0 auto 20px auto;background-repeat: no-repeat;background-position: 50%;background-size: cover;border-radius: 50%;"></div>' +
      '<div style="text-align: center;"><h2 style="margin-top: 26px;font-size: 18px;color: #060606;font-weight: bold;text-transform: capitalize;letter-spacing: 0.5px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">' + this.cardUsername + '</h2></div>' +
      '</div>';
    })
  }
    removePhoto(){
      this.imageData = "";
      document.getElementById('results').innerHTML =
      '<label>Ditt kort:</label>' +
      '<div style="height: 241px;width: 182px;display: block;margin: 0 auto;background-color: #fff;padding: 10px 10px 20px 10px;box-shadow: 0 5px 30px rgba(0,0,0,.30);border-radius: 10px;">' +
      '<div style="background-image: url(' + this.imageData + ');width: 100%;height: 0;padding-top: 100%;margin: 0 auto 20px auto;background-repeat: no-repeat;background-position: 50%;background-size: cover;border-radius: 50%;"></div>' +
      '<div style="text-align: center;"><h2 style="margin-top: 26px;font-size: 18px;color: #060606;font-weight: bold;text-transform: capitalize;letter-spacing: 0.5px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">' + this.cardUsername + '</h2></div>' +
      '</div>';
      this.photoTaken = false;
  }

  getMinDate(){
    let date = new Date();
    date.setFullYear((date.getFullYear()-18));
    this.minDate = date.toISOString().substring(0, 10);
    return this.minDate

  }
  getMaxDate(){
    let date = new Date();
    date.setFullYear((date.getFullYear()-8));
    this.maxDate = date.toISOString().substring(0, 10)
    return this.maxDate

  }

  redirectAfterSaveUser() {
    $('#signup-modal').modal('hide');
    this.router.navigateByUrl('checkin');
  }

  saveUser() {
    this.submitted = true;
    this.disableSignupButton = true;
      if(this.addUserForm.valid && this.validMobilePhone === true && this.validHomePhone === true && this.validmunicipalityAccess == true) {
        var aYearAgo = new Date();
        aYearAgo.setFullYear(aYearAgo.getFullYear() - 1);
        
        this.apiService.post('users', {

          'userName': this.addUserForm.value.userName,
          'avatarImage': this.chosenAvatar,
          'firstName': this.addUserForm.value.firstName,
          'lastName':  this.addUserForm.value.lastName,
          'gender':  this.addUserForm.value.gender,
          'dateOfBirth':  this.addUserForm.value.dateOfBirth,
          'ownImage':this.imageData,
          'address':  {
            'name': 'homeAddress',
            'address': this.addUserForm.value.address.address,
            'zip': this.addUserForm.value.address.zip,
            'postalZone': ""
          },
          'phone':[
            {'name': 'homePhone', 'number': this.addUserForm.value.homePhone},
            {'name': 'mobilePhone', 'number': this.addUserForm.value.mobilePhone}
            ],
          'municipality': this.addUserForm.value.municipality,
          'municipalityAccess': this.addUserForm.value.municipalityAccess,
          'latestVisit': aYearAgo
        }).then((response: any) => {
          $('#signup-modal').modal('show');
          this.userRegistered = true;
          this.modalTitle = "Uncan";
          this.modalMessage = 'Välkommen ' + this.firstToUpperCase(this.addUserForm.value.firstName) + ' ' + this.firstToUpperCase(this.addUserForm.value.lastName) + '! <br><br>Du är nu registrerad på uncan med användarnamnet: <strong>' + this.addUserForm.value.userName + '</strong>';
          setTimeout(() => {
            this.redirectAfterSaveUser();
          },10000)
        }).catch((err) => {

          if (err.status == 409){
            $('#signup-modal').modal('show');
            this.modalTitle = "Fel";
            this.userRegistered = false;
            this.modalMessage = 'Användarnamnet: <strong>' + this.addUserForm.value.userName + '</strong> finns redan, vänligen välj ett annat användarnamn.';
          }

          this.disableSignupButton = false;
        });
      } else {
        this.disableSignupButton = false;
        this.validmunicipalityAccess = false;
        console.log(this.addUserForm);
        window.scrollTo(0,0);
      }
  }

  firstToUpperCase(str) {
    return str.substr(0, 1).toUpperCase() + str.substr(1);
  }

  getMunicipalities() {
    this.apiService.get('municipalities').then((response:any) => {
        this.municipalities = response.data;
    }).catch((err) => {
    });
  }

  getGenders() {
    this.apiService.get('genders').then((response:any) => {
      this.genders= response.data;
      for (let i = 0; i < this.genders.length; i++) {
        if(this.genders[i].gender == 'other') {
          this.genders[i].gender = 'Ospecificerat';
        } else if(this.genders[i].gender == 'male') {
          this.genders[i].gender = 'Man';
        } else if(this.genders[i].gender == 'female') {
          this.genders[i].gender = 'Kvinna';
        }
      }
    }).catch((err) => {
    });
  }

  getAvatars(){
    this.apiService.get('avatars').then((response:any)=>{
      this.NumberOfAvatars= response.numberOfAvatars;
      for(var index = 0; index <= this.NumberOfAvatars ; index++ ){
        this.imagesArray.push(this.apiUrl+'avatar/'+index+'.png');
      }
      this.showLoadingSpinner = false;
    })
  }
  showTermsAndConditionsModal(){
    $('#signup-modal').modal('show');
    this.userRegistered = false;
    this.modalTitle = "Användarvillkor";
    this.modalMessage = environment.TermsAndConditions;
  }

waitForAllPromises(functionList){
  return function(){
    var promiseArray=[];

  }
}

}



// WEBPACK FOOTER //
// ./src/app/signup/signup.component.ts